module.exports = __webpack_public_path__ + "img/element-yh.798bea89.png";